<ng-template #topSimsContent>
  <div class="card card-animate mb-0 top-sims-card">
    <div class="card-header border-0 d-flex flex-wrap justify-content-between align-items-center gap-2">
      <div class="d-flex align-items-center gap-3">
        <div>
          <h5 class="card-title mb-1">{{ headerTitle }}</h5>
          <p class="text-muted mb-0 small">{{ headerSubtitle }}</p>
        </div>

        <div class="d-flex align-items-center gap-1">
          <div class="form-check form-switch form-switch-md mb-0">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              [checked]="horizontalScrollOn"
              (change)="horizontalScrollChange($event)"
            />
          </div>
          <span class="text-muted small">Horizontal Scroll &amp; Fixed Columns</span>
        </div>
      </div>

      <div class="d-flex flex-wrap align-items-center gap-2">
        <div class="input-group input-group-sm top-sims-search">
          <span class="input-group-text bg-light border-end-0">
            <i class="bi bi-search"></i>
          </span>
          <input type="text"
                 class="form-control border-start-0"
                 placeholder="Search..."
                 [(ngModel)]="searchTerm"
                 (input)="searchInput()" />
        </div>

        <button #filterToggleTooltip="ngbTooltip"
                type="button"
                class="btn btn-soft-secondary btn-sm top-sims-filter-toggle"
                [class.active]="devicesAllocated?.gridView?.filterRowVisible"
                [attr.aria-pressed]="devicesAllocated?.gridView?.filterRowVisible"
                [ngbTooltip]="devicesAllocated?.gridView?.showTooltips ? (devicesAllocated?.gridView?.filterRowVisible ? 'Hide Filters' : 'Show Filters') : null"
                placement="bottom"
                tooltipClass="custom-tooltip-success"
                (click)="filterToggleTooltip.close(); filterColumnsClick()">
          <i class="bi bi-funnel"></i>
        </button>
        <button type="button" class="btn btn-soft-secondary btn-sm" (click)="manageColumnsClick($event)">
          <i class="bi bi-columns-gap me-1"></i> Manage Columns
        </button>
        <button type="button" class="btn btn-soft-info btn-sm" (click)="viewAllClick()">
          <i class="bi me-1" [ngClass]="viewAllExpanded ? 'bi-arrow-bar-up' : 'bi-eye'"></i>
          {{ viewAllExpanded ? 'Show Top 10' : 'View All SIMs' }}
        </button>
        <div ngbDropdown class="d-inline-block">
          <button type="button" class="btn btn-soft-success btn-sm" ngbDropdownToggle>
            <i class="bi bi-box-arrow-up me-1"></i> Export
          </button>
          <div ngbDropdownMenu class="dropdown-menu-end">
            <button type="button" class="dropdown-item" (click)="exportAllExcelClick()">
              <i class="bi bi-file-earmark-excel me-2 text-success"></i> Export all to Excel
            </button>
            <button type="button" class="dropdown-item" (click)="exportAllPdfClick()">
              <i class="bi bi-file-earmark-pdf me-2 text-danger"></i> Export all to PDF
            </button>
            <div class="dropdown-divider"></div>
            <button type="button" class="dropdown-item" (click)="exportSelectedExcelClick()">
              <i class="bi bi-file-earmark-excel me-2 text-success"></i> Export selected to Excel
            </button>
            <button type="button" class="dropdown-item" (click)="exportSelectedPdfClick()">
              <i class="bi bi-file-earmark-pdf me-2 text-danger"></i> Export selected to PDF
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body pt-0 top-sims-grid-host" [class.compact-mode]="!viewAllExpanded">
      <app-devices-allocated-content-shared #devicesAllocated
        [compactMode]="true"
        [defaultSortBy]="usageSortColumn"
        [defaultSortOrder]="'desc'"
        [hostComponent]="hostName"
        [showFilterRowInitial]="false"
        [topNLimit]="topNLimit"
        (companyDataSaved)="companyDataSaved.emit()"
      ></app-devices-allocated-content-shared>
    </div>
  </div>
</ng-template>

@if (useContainer) {
  @if (visibleContainer) {
    <div class="row" [ngClass]="marginBottom">
      <div class="col-12">
        <div class="border border-success rounded">
          <div class="row">
            <div class="col-12">
              <div class="alert border-0 alert-primary d-flex justify-content-between align-items-center mb-0"
                   role="alert">
                <strong>{{containerTitle}}</strong>
                <div class="d-flex align-items-center" style="gap: 6px;">
                  <i class="fs-5"
                     [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                     style="cursor: pointer; color: #198754;"
                     (click)="toggleContainerExpansion()">
                  </i>
                  <i *ngIf="allowContainerClose"
                     class="fs-3 bx bx-x"
                     style="cursor: pointer; color: #dc3545;"
                     (click)="closeContainer()">
                  </i>
                </div>
              </div>
            </div>
          </div>

          @if (expandContainer) {
            <div class="row">
              <div class="col-12">
                <div class="mb-2 w-100 px-2 pt-2">
                  <ng-container *ngTemplateOutlet="topSimsContent"></ng-container>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="topSimsContent"></ng-container>
}
